// extracted by mini-css-extract-plugin
module.exports = {"expenses-list":"ExpenseList_expenses-list__eNFA1","expenses-list__fallback":"ExpenseList_expenses-list__fallback__24ilQ"};